import { useMemo, type FC } from 'react';
import {
  useDisclosure
} from '@chakra-ui/react';
import {
  UiStack,
  UiText,
  uiStyles,
  UiHStack,
  UiButton, UiLink, UiIconLink, UiIconArrowSquareOut,
} from '@/lib/ui';
import dayjs from 'dayjs';
import { type Order } from '@/api/registration/order';
import { useEventQuery } from '@/registration/hook/useEventQuery';
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterShareButton,
  XIcon
} from 'react-share';
import { generatePageUrl } from '@/app/pages';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import { type GroupRegistration } from '@/api/registration/groupRegistration';
import { type Registration } from '@/api/registration';
export interface RegistrationDetailsProps {
  registration: Registration
}

const RegistrationDetails: FC<RegistrationDetailsProps> = ({ registration }) => {
  const { isOpen, onToggle } = useDisclosure();
  const { tenantCode, eventId } = useRegisterRoute();
  const { data: event } = useEventQuery(registration.eventId);
  const url = useMemo(
    () => { return window.location.origin + generatePageUrl('RegistrationRegisterEmail', { tenantCode, eventId }); }
    , [eventId, tenantCode]);
  const title = useMemo(
    () => { return `I just registered for "${event?.name}"!`; }
    , [event?.name]);
  return (
    <>
      <UiStack
        bgColor={'#fff'}
        borderRadius={uiStyles.borderRadius}
        {...uiStyles.hover}
        onClick={onToggle}
        justifyContent={'space-between'}
        px={{ base: 4, lg: 8 }}
        py={8}
        spacing={4}
        enableDivider={true}
      >
        <UiHStack justifyContent={'space-between'}>
          <UiText variant='body1' color={'text.secondary'}>Name</UiText>
          <UiText variant='body1'>{registration.firstName} {registration.lastName}</UiText>
        </UiHStack>
        <UiHStack justifyContent={'space-between'}>
          <UiText variant='body1' color={'text.secondary'}>Email</UiText>
          <UiText variant='body1'>{registration.email}</UiText>
        </UiHStack>
        <UiHStack justifyContent={'space-between'}>
          <UiText variant='body1' color={'text.secondary'}>Event</UiText>
          <UiText variant='body1'>{registration.event.name}</UiText>
        </UiHStack>
        <UiHStack justifyContent={'space-between'}>
          <UiText variant='body1' color={'text.secondary'}>Tickets</UiText>
        </UiHStack>
        <UiHStack justifyContent={'space-between'}>
          <UiText variant='caption'>{'Name'}</UiText>
          <UiText variant='caption'>{'Quantity'}</UiText>
        </UiHStack>
        <UiHStack justifyContent={'space-between'}>
          <UiText variant='body2'>{registration.mainEventTicket}</UiText>
          <UiText variant='body2'>{1}</UiText>
        </UiHStack>
        {registration?.otherTickets?.map((ticket, index) => {
          return (
            <UiHStack key={index} justifyContent={'space-between'}>
              <UiText variant='body2'>{ticket.name}</UiText>
              <UiText variant='body2'>{ticket.quantity}</UiText>
            </UiHStack>
          );
        })}

      </UiStack>
      <UiHStack justifyContent={'flex-end'}>
        <LinkedinShareButton url={url} title={title}>
          <LinkedinIcon size={32} round={true} />
        </LinkedinShareButton>
        <TwitterShareButton url={url} title={title}>
          <XIcon size={32} round={true} />
        </TwitterShareButton>
        <FacebookShareButton url={url}>
          <FacebookIcon size={32} round={true} />
        </FacebookShareButton>
        {/*<UiButton*/}
        {/*  px={8}*/}
        {/*  size={'lg'}*/}
        {/*  shadow={'base'}*/}
        {/*  colorScheme={'primary'}*/}
        {/*  onClick={() => { return window.open(event?.websiteUrl, '_blank'); }}*/}
        {/*>*/}
        {/*  Go to {registration.event.name} website*/}
        {/*</UiButton>*/}
        <UiLink href={event?.websiteUrl ?? undefined} target={'_blank'}>
          <UiHStack spacing={4}>
            <UiText>Go to {registration.event.name} website</UiText>
            <UiIconArrowSquareOut size={'2xl'} color={'primary.500'}/>
          </UiHStack>
        </UiLink>
      </UiHStack>
    </>
  );
};

export default RegistrationDetails;
